/**
 * 生成一个用不重复的ID
 * @param randomLength id  长度
 */
export const getUuid = (randomLength = 32): string => {
  return 'key:' + Number(Math.random().toString().substring(2, randomLength) + Date.now()).toString(36);
};

/**
 * 屏幕滚动到置顶元素所在位置，并且这个元素在页面是居中的
 * @param element 元素
 */
export const scrollToElement = (element: HTMLElement) => {
  const elRect = element.getBoundingClientRect();
  const elTop = elRect.top;
  const elHeight = elRect.height;
  const windowHeight = window.innerHeight;
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollTo = elTop + scrollTop - windowHeight / 2 + elHeight / 2;

  window.scrollTo({
    top: scrollTo,
    behavior: 'smooth',
  });
};
